import { render, staticRenderFns } from "./CalendarLayout.vue?vue&type=template&id=04df3bae"
import script from "./CalendarLayout.vue?vue&type=script&lang=js"
export * from "./CalendarLayout.vue?vue&type=script&lang=js"
import style0 from "./CalendarLayout.vue?vue&type=style&index=0&id=04df3bae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports